module.exports = { src: __webpack_public_path__ + "media/tile-4-image.7ac14789.webp", width: 540, height: 375 };